'use strict';

import React from 'react';
import moment from "moment";
import OTIcon from "../tag/OTIcon";
import {Button} from "@material-ui/core";
import {FormattedMessage} from 'react-intl';

const getModifierMessageId = (role) => {
    switch (role) {
        case 'Potilas': return 'form.draft.info.modified.potilas';
        case 'Ammattilainen': return 'form.draft.info.modified.ammattilainen';
        case 'Puolesta-asioija': return 'form.draft.info.modified.puolesta-asioija';
        default: return undefined;
    }
}

const FormDraftInfo = (props) => {
    const [hide, setHide] = React.useState(false);
    const lastModifiedDate = props.form?.formDataLastModifiedDate ? moment(props.form?.formDataLastModifiedDate).format("DD.MM.yyyy HH:mm") : "";
    const modifierMessageId = getModifierMessageId(props?.form?.formDataLastModifiedRole);
    return ((hide === false && props?.form?.status === 'DRAFT') ?
      <div className={'formula-query-info'}>
          <div className={'formula-query-infoitems'}>
          <span>
                <FormattedMessage id="form.draft.info.modified" />
          </span>
          <br/>
          <span>
              {lastModifiedDate}
          </span>
          <br/><br/>
          <span>
           <OTIcon
               config={{type: 'fa', name: 'icon-info'}}
               className="formula-query-infoicon"
           />   <FormattedMessage id="form.draft.info" />
          </span>
          </div>
          <div className={'formula-query-infobutton-container'}>
              <Button className={'formula-query-infobutton'} onClick={() => setHide(true)}>
                  <FormattedMessage id="form.draft.info.ok" />
              </Button>
          </div>
      </div>
             :
             props?.form?.status === 'SUBMIT' ?
                 <div className={'formula-query-info'}>
                     <div className={'formula-query-infoitems'}>
                         {
                             modifierMessageId ?
                                 <FormattedMessage
                                     id={modifierMessageId}
                                     values={{lastModifiedDate: lastModifiedDate}}/> :
                                 <></>
                         }
                     </div>
                 </div>
                 :

             <></>
  )
};

export default FormDraftInfo;
